/**
 * @file 发送上报
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/request
 */
import { toQuery } from './json';
import delay from './delay';
import storage from './storage';
import { Config, injectCommonField, isReady, onReady } from './config';
import xhr from './xhr';
/**
 * 发送上报请求
 *
 * @function request.post
 * @param {string} url 上报地址
 * @param {Object|string} jsonOrString 键值对对象或字符串
 * @param {Function=} callback 上报后的回调
 * @param {Array=} data post 的数据
 */

export var post = function post(url, jsonOrString, callback) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  // 这里的 type 是上报类型对应的地址，比如 view 事件，对应的默认就是 pv0.gif 。
  var query = injectCommonField(toQuery(jsonOrString), {
    type: url
  });

  if (query) {
    url += "?".concat(query);
  }

  storage.save(url, data);
  storage.pending(url); // 静态文件是否通过file协议

  var isFileProtocol = document && document.location.protocol === 'file:'; // 通过file协议访问时添加https协议

  var targetURL = isFileProtocol ? "https:".concat(Config.DOMAIN).concat(url) : Config.DOMAIN + url;
  var isSuccess = data.length ? navigator.sendBeacon(targetURL, JSON.stringify(data)) : navigator.sendBeacon(targetURL);

  if (isSuccess && navigator.onLine) {
    storage.remove(url, data);
    storage.resend(post);
  }

  callback && callback();
};
var delayPost = delay(post);
/**
 * 发送上报请求
 *
 * @function request.get
 * @param {string} url 上报地址
 * @param {Object|string} jsonOrString 键值对对象或字符串
 * @param {Function=} callback 上报后的回调
 */

export var get = function get(url, jsonOrString, callback) {
  // TODO 在这里计算 req_idx
  var query = injectCommonField(toQuery(jsonOrString), {
    type: url
  });

  if (query) {
    url += "?".concat(query);
  }

  storage.save(url); // 静态文件是否通过file协议

  var isFileProtocol = document && document.location.protocol === 'file:'; // 通过file协议访问时添加https协议

  var targetURL = isFileProtocol ? "https:".concat(Config.DOMAIN).concat(url) : Config.DOMAIN + url;
  xhr(targetURL, function (isSuccess) {
    if (isSuccess) {
      storage.remove(url);
      storage.resend(get);
    }

    callback && callback();
  });
  storage.pending(url);
};
var delayGet = delay(get);
/**
 * 发送上报请求
 *
 * @param {string=} verb HTTP Verb
 * @param {boolean} isRunAtOnce 是否立即上报
 * @return {Function} 选择到的上报提交方法
 */

export default function request(verb, isRunAtOnce) {
  var isImmediateSend = isRunAtOnce || !Config.DELAY;
  var requester = String(verb).toLowerCase() === 'post' && navigator.sendBeacon ? isImmediateSend ? post : delayPost : isImmediateSend ? get : delayGet;

  if (isReady()) {
    return requester;
  }

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return onReady(function () {
      return requester.apply(void 0, args);
    });
  };
}